import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_X_CIRCLE: GlameraIconDefinition = {
  name: 'x-circle',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-x-circle-ring" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path>
    <path class="glm-x-circle-line" pathLength="1" d="m9.75 9.75 4.5 4.5"></path>
    <path class="glm-x-circle-line glm-x-circle-line-2" pathLength="1" d="m14.25 9.75-4.5 4.5"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-x-circle-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './x-circle.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class XCircleIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_X_CIRCLE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
